module.exports = __webpack_public_path__ + "media/images/stratified-weight-investment-93236afa54b6bb47c79ec2a6bf1cd707.png";